import { ServiceTable } from "./libs/service-table";

export {ServiceTable};